<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, sortBy, update } from "lodash";
import groupBy from "lodash/groupBy";
import Swal from "sweetalert2";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import RatingScale from "@/components/modals/rating-scale.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import TPMSList from "@/components/widgets/tpms-list.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "PMT Targets Rating"
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    AttachmentModal,
    RatingScale,
    PrintOptions,
    Multiselect,
    TPMSList
  },
  data() {
    return {
      title: "PMT Targets Rating",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "PMT Targets Rating",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
        includeThousandsSeparator: false
      }),
      movFields: [
        {
          key: "mode",
          label: "Mode",
          sortable: true
        },
        {
          key: "description",
          label: "Description",
          sortable: true
        },
        {
          key: "attachments",
          label: "Attachments"
        }
      ],
      targetList: [],
      clusterOptions: [],
      selectedCluster: null,
      duOptions: [],
      selectedDu: null,
      filter: "",
      duBusy: false,
      targetBusy: false,
      weightSPC: 90,
      weightMandatorySupportFunctions: 10,
      aveSPC: 0,
      aveMandatorySupportFunctions: 0,
      finalScore: 0,
      modalTitle: "",
      uploadTitle: "",
      rating: null,
      actualSelected: null,
      returnForm: {
        id: null,
        remarks: ""
      },
      tabOptions: [
        { types: ["Strategic Priority", "Core Function"] },
        { types: ["Mandatory Support Function"] }
      ],
      attachmentLoading: true,
      attachments: [],
      movData: [],
      returnRemarks: [],
      returnRemarksTitle: "",
      fileSearch: "",
      attachmentQuarter: 0,
      indexOffice: -1,
      indexKpi: -1,
      indexTarget: -1,
      tabIndex: 0,
      rateType: "",
      returnType: "",
      filteredReport: false,
      campusList: [],
      prexcList: [],
      selectedCampusPrint: null,
      selectedClusterPrint: null,
      selectedClassificationPrint: null,
      selectedPrexcPrint: [],
      selectedClassification: {
        classifications: [],
        finalRating: null
      },
      printType: "Campus"
    };
  },
  async mounted() {
    this.pageLoader(true);
    await this.getClusters();
    this.pageLoader(false);
  },
  computed: {
    groupedPrexc() {
      var array = [];
      var group = groupBy(this.prexcList, "prexcClassificationId");
      for (const key in group) {
        array.push({
          id: key,
          classification: group[key][0].prexcClassification.classification,
          prexcList: group[key]
        });
      }
      return array;
    }
  },
  methods: {
    filteredTarget(props) {
      let data = props.details;
      data = data.filter((item) => {
        if (this.tabIndex == 0)
          return (
            item.searchKey.toUpperCase().includes(this.filter.toUpperCase()) &&
            item.accomplishmentStatus == "SUBMITTED"
          );
        else if (this.tabIndex == 1)
          return (
            item.searchKey.toUpperCase().includes(this.filter.toUpperCase()) &&
            item.accomplishmentStatus == "COMPLETED"
          );
        else if (this.tabIndex == 2)
          return item.searchKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
      });
      return data;
    },
    changeCycle(cycle) {
      this.getAllDu(cycle);
    },
    getClusters() {
      this.$store
        .dispatch("cluster/GetCluster")
        .then((res) => {
          let cycle = this.$store.state.data.cycle;
          res.data.forEach((cluster) => {
            cluster.submittedCount = 0;
            this.$store
              .dispatch("target/GetDuWithSubmittedAndCompletedTarget", {
                cycle: cycle,
                clusterId: cluster.id
              })
              .then((resDu) => {
                resDu.data.forEach((du) => {
                  cluster.submittedCount =
                    cluster.submittedCount + du.submittedCount;
                });
                this.clusterOptions = res.data.sort(function (a, b) {
                  if (b.submittedCount > 0) return 1;
                  else if (a.submittedCount > 0) return -1;
                  else return a.clusterName.localeCompare(b.clusterName);
                });
              });
          });
        })
        .catch(() => {
          this.showToast(
            "Something went wrong! Cannot fetch clusters. Please contact your administrator.",
            "error"
          );
        });
    },
    getAllDu(cycle) {
      if (!this.selectedCluster) return;
      this.duOptions = [];
      this.selectedDu = null;
      this.duBusy = true;
      this.$store
        .dispatch("target/GetDuWithSubmittedAndCompletedTarget", {
          cycle: cycle,
          clusterId: this.selectedCluster.id
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.duOptions = cloneDeep(
            res.data.sort(function (a, b) {
              if (b.submittedCount > 0) return 1;
              else if (a.submittedCount > 0) return -1;
              else if (
                a.deliveryUnitName.toUpperCase().trim() ==
                b.deliveryUnitName.toUpperCase().trim()
              )
                return a.campusName.localeCompare(b.campusName);
              else return a.deliveryUnitName.localeCompare(b.deliveryUnitName);
            })
          );
          this.duBusy = false;
        })
        .catch(() => {
          this.duBusy = false;
          this.showToast("Something went wrong!", "error");
        });
    },
    async getAllTargets() {
      this.targetBusy = true;
      this.selectedClassification = {
        items: [],
        finalRating: null
      };
      await this.$store
        .dispatch("target/GetSimpleCompletedTargetByDu", {
          cycle: this.$store.state.data.cycle,
          deliveryUnitId: this.selectedDu.deliveryUnitId
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.targetList = [];
          if (!res.data.targets || res.data.targets.length == 0) {
            this.targetBusy = false;
            return;
          }
          res.data.targets.map((item) => {
            item.description = item.targetDescription || "";
            item.showDetails = false;
            item.deliveryUnit = cloneDeep(this.selectedDu);
            item.evaluationScoreQuality = item.scoreQuality.toString();
            item.evaluationScoreEfficiency = item.evaluationScoreEfficiency.toString();
            item.evaluationScoreTimeliness = item.evaluationScoreTimeliness.toString();
            item.qualityOptions = [];
            item.efficiencyOptions = [];
            item.timelinessOptions = [];
            item.searchKey = `${item.indicatorItemName} ${item.targetDescription}`;
          });
          this.targetList = res.data.targets;
          this.selectedClassification = JSON.parse(JSON.stringify({
            items: res.data.classifications,
            finalRating: res.data.finalRating
          }));
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      setTimeout(() => {
        this.targetBusy = false;
      }, 500);
    },
    setScore() {
      // Calculate the average score for each type
      this.aveSPC = this.typeAveScore(["Strategic Priority", 'Core Function']);
      this.aveMandatorySupportFunctions = this.typeAveScore(["Mandatory Support Function"]);

      // Calculate the final score by adding all the weighted scores
      this.finalScore = (
        parseFloat(this.aveSPC.toFixed(2)) +
        parseFloat(this.aveMandatorySupportFunctions.toFixed(2))
      ).toFixed(2);
    },
    async getMOV(id) {
      this.movData = [];
      await this.$store.dispatch("mov/GetMOVByTarget", id).then(async (res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, "error");
        }
        res.data.forEach((item) => {
          item.attachments = [];
          item.addDocu = false;
          item.uploadOptions = null;
        });
        this.movData = res.data;
        this.movData.push({
          id: `others-${id}`,
          targetId: id,
          target: null,
          mode: "OTHERS",
          description: "",
          attachments: [],
          addDocu: false,
          uploadOptions: null
        });
        this.movData.push({
          id: `catchup-${id}`,
          targetId: id,
          target: null,
          mode: "CATCHUP PLANS",
          description: "",
          attachments: [],
          addDocu: false,
          uploadOptions: null
        });
      });
    },
    viewReturnRamarks({ pmeLogs, pmtLogs }) {
      pmeLogs = pmeLogs ? pmeLogs : [];
      let logs = pmeLogs.concat(pmtLogs);
      this.returnRemarksTitle = "View Logs";
      this.returnRemarks = logs.sort((a, b) => new Date(b.remarksDate) - new Date(a.remarksDate));
      this.returnRemarks.forEach((item) => {
        item.dateWTime = this.formatDateWithTime(new Date(item.remarksDate));
        item.splitted = item.dateWTime.split(" at ");
        item.Employee = item.employee;
        item.Remarks = item.remarks;
      });
      this.$bvModal.show("return-remarks-modal");
    },
    getQETRating(row) {
      this.$store.dispatch("ratingscale/GetRatingScale", row.id).then((res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, 'error');
        }
        if (res.data.length > 0) {
          row.qualityOptions = res.data.filter((item) => {
            return item.type == "EFFECTIVENESS/QUALITY";
          });
          row.efficiencyOptions = res.data.filter((item) => {
            return item.type == "EFFICIENCY";
          });
          row.timelinessOptions = res.data.filter((item) => {
            return item.type == "TIMELINESS";
          });
        }
        this.$forceUpdate();
      }).catch(error => {
        console.log(error)
      })
    },
    limitRating(row) {
      if (parseFloat(row.evaluationScoreQuality) > 5)
        row.evaluationScoreQuality = "5";
      if (parseFloat(row.evaluationScoreQuality) < 0)
        row.evaluationScoreQuality = "0";
      if (parseFloat(row.evaluationScoreEfficiency) > 5)
        row.evaluationScoreEfficiency = "5";
      if (parseFloat(row.evaluationScoreEfficiency) < 0)
        row.evaluationScoreEfficiency = "0";
      if (parseFloat(row.evaluationScoreTimeliness) > 5)
        row.evaluationScoreTimeliness = "5";
      if (parseFloat(row.evaluationScoreTimeliness) < 0)
        row.evaluationScoreTimeliness = "0";
      this.$forceUpdate();
    },
    async updateTarget(row, withToast) {
      if (row.evaluationScoreQuality == "") row.evaluationScoreQuality = 0;
      if (row.evaluationScoreEfficiency == "")
        row.evaluationScoreEfficiency = 0;
      if (row.evaluationScoreTimeliness == "")
        row.evaluationScoreTimeliness = 0;
      await this.$store
        .dispatch("target/UpdateTarget", row)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          if (withToast) this.showToast("Successfully saved!", "success");
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    onRateTarget() {
      let updateData = JSON.parse(JSON.stringify(this.actualSelected));
      let newData = {
        id: updateData.id,
        q1: updateData.q1,
        q2: updateData.q2,
        q3: updateData.q3,
        q4: updateData.q4,
        points: updateData.points,
        cascadedTarget: updateData.cascadedTarget,
        remarks: updateData.targetDescription,
        finalRemarks: updateData.finalRemarks,
        deliveryUnitId: this.selectedDu.deliveryUnitId,
        scoreEfficiency: updateData.scoreEfficiency,
        evaluationScoreEfficiency: updateData.evaluationScoreEfficiency,
        scoreQuality: updateData.scoreQuality,
        evaluationScoreQuality: updateData.evaluationScoreQuality,
        scoreTimeliness: updateData.scoreTimeliness,
        evaluationScoreTimeliness: updateData.evaluationScoreTimeliness,
        planningRemarks: updateData.planningRemarks,
        planningFeedback: updateData.planningFeedback,
        isNotApplicable: updateData.isNotApplicable,
        measure: updateData.measure,
        frequency: updateData.frequency,
        risk: updateData.risk,
        actualAccomplishment: updateData.actualAccomplishment,
        annualTarget: updateData.annualTarget,
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to save this target's rating",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, save!"
      }).then(async (result) => {
        if (result.value) {
          await this.updateTarget(newData, false);
          let remarks = this.rateType.includes("SUBMITTED")
            ? "Review Completed"
            : "Updated Review";
          this.$store
            .dispatch("target/CompleteTarget", {
              id: updateData.id,
              body: remarks
            })
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              updateData.targetLogs = res.data;
              updateData.accomplishmentStatus = "COMPLETED";
              this.selectedDu.submittedCount - 1;
              let targetIndex = this.targetList.findIndex(x => x.id == updateData.id);
              this.targetList.splice(targetIndex, 1, updateData);
              this.setScore();
              this.$bvModal.hide("rate-modal");
              this.showToast("Successfully saved!", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be saved!", "error");
            });
        }
      });
    },
    rateTarget(row) {
      this.submitted = false;
      this.rateType = row.accomplishmentStatus;
      this.actualSelected = cloneDeep(row);
      // this.indexKpi = this.targetList.findIndex(
      //   (item) => item.indicatorItemId == row.indicatorItemId
      // );
      // this.indexTarget = this.targetList[this.indexKpi].details.findIndex(
      //   (item) => item.id == row.id
      // );
      this.returnForm = {
        id: row.id,
        remarks: ""
      };
      this.getQETRating(this.actualSelected);
      this.modalTitle = this.rateType.includes("COMPLETED")
        ? `Update Rating`
        : `Rate Target`;
      this.$bvModal.show("rate-modal");
    },
    onReturnTarget() {
      this.submitted = true;
      if (this.returnForm.remarks.trim() == "") {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to return this target for Secretariat review",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, return it!"
      }).then((result) => {
        if (result.value) {
          if (this.returnType.includes("return submitted")) {
            let remarks = "Return to Secretariat Review:".concat(
              " ",
              this.returnForm.remarks
            );
            this.$store
              .dispatch("target/ReturnToPostTarget", {
                id: this.returnForm.id,
                body: remarks
              })
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                this.targetList[this.indexKpi].details.splice(
                  this.indexTarget,
                  1
                );
                if (this.targetList[this.indexKpi].details.length == 0)
                  this.targetList.splice(this.indexKpi, 1);
                this.$bvModal.hide("return-modal");
                this.showToast("Successfully returned!", "success");
              })
              .catch((err) => {
                this.showToast("Something went wrong!", "error");
              });
          } else if (this.returnType.includes("return completed")) {
            let remarks = "Return to PMT Review:".concat(
              " ",
              this.returnForm.remarks
            );
            this.$store
              .dispatch("target/SubmitTarget", {
                id: this.returnForm.id,
                body: remarks
              })
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                if (this.returnType.includes("return completed - all")) {
                  this.targetList[this.indexKpi].details[
                    this.indexTarget
                  ].accomplishmentStatus = "SUBMITTED";
                } else {
                  this.targetList[this.indexKpi].details.splice(
                    this.indexTarget,
                    1
                  );
                  if (this.targetList[this.indexKpi].details.length == 0)
                    this.targetList.splice(this.indexKpi, 1);
                }
                this.$bvModal.hide("return-modal");
                this.showToast("Successfully returned!", "success");
              })
              .catch((err) => {
                this.showToast("Something went wrong!", "error");
              });
          }
        }
      });
      this.submitted = false;
    },
    returnTarget({ row, type }) {
      this.submitted = false;
      this.returnType = type;
      this.actualSelected = cloneDeep(row);
      this.indexKpi = this.targetList.findIndex(
        (item) => item.indicatorItemId == row.indicatorItemId
      );
      this.indexTarget = this.targetList[this.indexKpi].details.findIndex(
        (item) => item.id == row.id
      );
      this.returnForm = {
        id: row.id,
        remarks: ""
      };
      this.modalTitle = "Return Target";
      this.$bvModal.show("return-modal");
    },
    typeWeight(arrType) {
      if (arrType.length > 1) return this.weightSPC;
      else if (arrType.includes("Mandatory Support Function"))
        return this.weightMandatorySupportFunctions;
    },
    typeAve(arrType) {
      if (arrType.includes("Strategic Priority")) return this.aveSPC;
      else if (arrType.includes("Mandatory Support Function"))
        return this.aveMandatorySupportFunctions;
    },
    typeAveScore(arrType) {
      // Filter the targetList based on the type
      let arr = this.targetList;
      let data = [];
      arrType.map(type => {
        data = data.concat(arr.filter((item) => {
          return item.category.toLowerCase().includes(type.toLowerCase());
        }));
      });
      if (data.length === 0 || this.typeWeight(arrType) === 0) {
        return 0;
      }
      // Calculate the average score for this type
      let count = 0;
      let score = 0;
      data.forEach((target) => {
        if (!target.isNotApplicable) {
          count++;
          score +=
            parseFloat(
              this.calcAve(
                target.evaluationScoreQuality,
                target.evaluationScoreEfficiency,
                target.evaluationScoreTimeliness
              )
            );
        }
      });
      // Calculate the average and apply the weight
      let ave = count > 0 ? score / count : 0;
      let finalAve = ave * (this.typeWeight(arrType) / 100);
      return isNaN(finalAve) ? 0 : finalAve;
    },
    calcAve(scoreQuality, scoreEfficiency, scoreTimeliness) {
      let sum =
        parseFloat(scoreQuality) +
        parseFloat(scoreEfficiency) +
        parseFloat(scoreTimeliness);

      var count = 0;
      if (parseFloat(scoreQuality) != 0) count++;
      if (parseFloat(scoreEfficiency) != 0) count++;
      if (parseFloat(scoreTimeliness) != 0) count++;

      let ave = sum / count;
      return isNaN(ave) ? 0 : ave;
    },
    viewAttachments(row) {
      this.uploadTitle = `Target Attachment`;
      this.$refs.attachmentModal.setUploadOpt({
        type: `Target`,
        placement: "left",
        folder: "Planning"
      });
      this.$refs.attachmentModal.getData(row.id);
      this.$bvModal.show("upload-attachment-modal");
    },
    async getAttachments(row) {
      this.modalTitle = `View Attachments`;
      this.$bvModal.show("modal-allAttachments");
      this.attachmentLoading = true;
      this.attachments = [];
      row.mov = [];
      await this.getMOV(row.id);
      row.mov = this.movData;
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "Target"
        })
        .then((res) => {
          this.attachments = this.attachments.concat(res.data);
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      await this.movData.forEach((item) => {
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 1 Files: ${item.mode}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 1 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 1 Files: ${item.id}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 1 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 2 Files: ${item.mode}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 2 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 2 Files: ${item.id}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 2 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 3 Files: ${item.mode}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 3 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 3 Files: ${item.id}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 3 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 4 Files: ${item.mode}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 4 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 4 Files: ${item.id}`
          })
          .then((res) => {
            this.attachments = this.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 4 files",
              "error"
            );
          });
      });
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "Catchup Plan Attachment"
        })
        .then((res) => {
          this.attachments = this.attachments.concat(res.data);
        })
        .catch(() => {
          this.showToast(
            "Something went wrong! - getting catchup plan files",
            "error"
          );
        });
      await setTimeout(() => {
        this.attachmentLoading = false;
      }, 500);
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    searchDocu(type) {
      let data = type
        ? this.attachments.filter((item) => {
          return item.type == type;
        })
        : this.attachments;
      if (this.fileSearch.trim() != "" && this.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(this.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    searchQuarterDocu(modeType, idType) {
      //tungod sayop ang first type sa docu
      let modeDocu = this.attachments.filter((item) => {
        return item.type == modeType;
      });
      let idDocu = this.attachments.filter((item) => {
        return item.type == idType;
      });
      let data = modeDocu.concat(idDocu);
      if (this.fileSearch.trim() != "" && this.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(this.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    filterDocuByType(attachments, modeType, idType) {
      //tungod sayop ang first type sa docu
      let modeDocu = attachments.filter((item) => {
        return item.type.includes(modeType);
      });
      let idDocu = attachments.filter((item) => {
        return item.type.includes(idType);
      });
      let data = modeDocu.concat(idDocu);
      return data;
    },
    getPerformanceRating(row) {
      this.$refs.RatingScale.setMeasurement(row, "pmt");
    },
    printTPMS(officeId) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/TPMS",
        routeVariables: [this.$store.state.data.cycle, officeId]
      });
      this.$bvModal.show("print-options-modal");
    },
    printRatedOPCR(officeId) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/Rated/Opcr",
        routeVariables: [this.$store.state.data.cycle, officeId]
      });
      this.$bvModal.show("print-options-modal");
    },
    printFilteredRatedOPCR() {
      if (this.printType === "Campus" && this.selectedCampusPrint) {
        let campusId = (this.selectedCampusPrint && this.selectedCampusPrint.length > 0) ? this.selectedCampusPrint[0].Id : 0;
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Rated/OPCR/Campus",
          routeVariables: [this.$store.state.data.cycle, campusId]
        });
        this.$bvModal.show("print-options-modal");
      } else if (this.printType === 'Cluster' && this.selectedClusterPrint) {
        let clusterId = this.selectedClusterPrint.id;
        let campusIds = [];
        this.selectedCampusPrint.forEach((campus) => {
          campusIds.push(campus.Id);
        });
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Rated/OPCR/Campus/Cluster",
          routeVariables: [this.$store.state.data.cycle, clusterId],
          body: campusIds
        });
        this.$bvModal.show("print-options-modal");
      } else if (
        this.printType === 'PREXC' &&
        this.selectedClassificationPrint &&
        this.selectedPrexcPrint.length > 0
      ) {
        let campusId = (this.selectedCampusPrint && this.selectedCampusPrint.length > 0) ? this.selectedCampusPrint[0].Id : 0;
        let classificationId = this.selectedClassificationPrint.id;
        let prexcIdArray = this.selectedPrexcPrint;

        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Rated/OPCR/Campus",
          routeVariables: [
            this.$store.state.data.cycle,
            campusId,
            classificationId
          ],
          body: prexcIdArray
        });
        this.$bvModal.show("print-options-modal");
      } else if (this.printType === "SubmissionDates") {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Target/Submission/Date",
          routeVariables: [this.$store.state.data.cycle],
        });
        this.$bvModal.show("print-options-modal");
      } else if (this.printType === "Summary") {
        let campusId = (this.selectedCampusPrint && this.selectedCampusPrint.length > 0) ? this.selectedCampusPrint[0].Id : 0;
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/Target/Submission/Summary",
          routeVariables: [this.$store.state.data.cycle, campusId],
        });
        this.$bvModal.show("print-options-modal");
      } else return;
      this.filteredReport = false;
    },
    async renderSelection() {
      this.selectedCampusPrint = [{
        CampusName: this.$store.state.data.selectedCampus.campusName,
        Id: this.$store.state.data.selectedCampus.id
      }];
      this.selectedClusterPrint = this.selectedCluster ? this.selectedCluster : null;
      this.selectedClassificationPrint = null;
      this.selectedPrexcPrint = [];
      this.printType = "Campus"; // Reset to default
      this.campusList = await this.$store.state.decrypt.campusAccessList();
      await this.$store
        .dispatch("prexc/GetPrexc")
        .then((res) => {
          this.prexcList = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      this.filteredReport = true;
    }
  }
};
</script>
<template>
  <Layout @changeCycle="changeCycle($event)">
    <PageHeader :title="title" :items="items" />
    <!-- Attachments -->
    <b-modal id="modal-allAttachments" :title="modalTitle" size="lg" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <div class="row mb-3">
        <div class="col-md-4">
          <input type="search" class="form-control" placeholder="Search Attachments" v-model="fileSearch"
            @input="searchDocu()" />
        </div>
      </div>
      <b-row class="mt-2">
        <b-col>
          <h5 v-if="attachmentLoading">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-center align-items-center ms-4 font-size-14">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </div>
            </div>
          </h5>
          <h5 v-else-if="searchDocu().length == 0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span v-if="fileSearch">Search not found.</span>
                <span v-else>No document found.</span>
              </div>
            </div>
          </h5>
          <div v-else>
            <div v-if="searchDocu('Target').length > 0" class="row mb-3">
              <div class="col-md-12">
                <b class="text-white font-size-14">Target Documents</b>
              </div>
              <div class="col-md-4" v-for="(z, index) in searchDocu('Target')" :key="z.id">
                <div class="position-relative cursor-pointer border mt-2 br-5 mb-2"
                  :style="`z-index: ${searchDocu('Target').length - index}`">
                  <div class="border p-3" @click="openDocument(z)">
                    <div>
                      <div class="avatar-xs me-3 mb-2">
                        <div class="avatar-title bg-transparent rounded">
                          <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                          <i v-if="z.fileType.includes('application')"
                            class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="overflow-hidden me-auto">
                          <h5 class="font-size-14 text-truncate mb-1">
                            {{ z.description }}
                          </h5>
                          <p class="text-muted mb-0">
                            {{
                              formatDateWithTime(new Date(z.dateTimeUploaded))
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="mov in movData" :key="mov.id" class="row">
              <div v-if="
                filterDocuByType(
                  searchDocu(),
                  `Files: ${mov.mode}`,
                  `Files: ${mov.id}`
                ).length > 0
              " class="mb-1">
                <b class="text-white font-size-14">{{ mov.mode }}</b>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 1 Files: ${mov.mode}`,
                  `Quarter 1 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 1 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 1 Files: ${mov.mode}`,
                  `Quarter 1 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 1 Files: ${mov.mode}`,
                    `Quarter 1 Files: ${mov.id}`
                  ).length - index}`
                    ">
                    <div class="border p-3" @click="openDocument(z)">
                      <div>
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 2 Files: ${mov.mode}`,
                  `Quarter 2 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 2 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 2 Files: ${mov.mode}`,
                  `Quarter 2 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 2 Files: ${mov.mode}`,
                    `Quarter 2 Files: ${mov.id}`
                  ).length - index}`
                    ">
                    <div class="border p-3" @click="openDocument(z)">
                      <div>
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 3 Files: ${mov.mode}`,
                  `Quarter 3 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 3 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 3 Files: ${mov.mode}`,
                  `Quarter 3 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 3 Files: ${mov.mode}`,
                    `Quarter 3 Files: ${mov.id}`
                  ).length - index}`
                    ">
                    <div class="border p-3" @click="openDocument(z)">
                      <div>
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="
                searchQuarterDocu(
                  `Quarter 4 Files: ${mov.mode}`,
                  `Quarter 4 Files: ${mov.id}`
                ).length > 0
              " class="row">
                <div class="text-white font-size-12">Quarter 4 Files</div>
                <div class="col-md-4 mb-2" v-for="(z, index) in searchQuarterDocu(
                  `Quarter 4 Files: ${mov.mode}`,
                  `Quarter 4 Files: ${mov.id}`
                )" :key="z.id">
                  <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchQuarterDocu(
                    `Quarter 4 Files: ${mov.mode}`,
                    `Quarter 4 Files: ${mov.id}`
                  ).length - index}`
                    ">
                    <div class="border p-3" @click="openDocument(z)">
                      <div>
                        <div class="avatar-xs me-3 mb-2">
                          <div class="avatar-title bg-transparent rounded">
                            <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                            <i v-if="z.fileType.includes('application')"
                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="overflow-hidden me-auto">
                            <h5 class="font-size-14 text-truncate mb-1">
                              {{ z.description }}
                            </h5>
                            <p class="text-muted mb-0">
                              {{
                                formatDateWithTime(new Date(z.dateTimeUploaded))
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3" v-if="searchDocu('Catchup Plan Attachment').length > 0">
              <div class="col-md-12">
                <b class="text-white font-size-14">Catchup Plan / Justification Documents</b>
              </div>
              <div class="col-md-4" v-for="(z, index) in searchDocu('Catchup Plan Attachment')" :key="z.id">
                <div class="position-relative cursor-pointer border mt-2 br-5 mb-2" :style="`z-index: ${searchDocu('Catchup Plan Attachment').length -
                  index}`
                  ">
                  <div class="border p-3" @click="openDocument(z)">
                    <div>
                      <div class="avatar-xs me-3 mb-2">
                        <div class="avatar-title bg-transparent rounded">
                          <i v-if="z.fileType.includes('image')" class="mdi mdi-image font-size-24 text-purple"></i>
                          <i v-if="z.fileType.includes('application')"
                            class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="overflow-hidden me-auto">
                          <h5 class="font-size-14 text-truncate mb-1">
                            {{ z.description }}
                          </h5>
                          <p class="text-muted mb-0">
                            {{
                              formatDateWithTime(new Date(z.dateTimeUploaded))
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Return Actual -->
    <b-modal id="return-modal" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop
      no-close-on-esc>
      <div class="mb-3">
        <label class="form-label">Reason for {{ modalTitle }}</label>
        <textarea rows="3" autocomplete="off" class="form-control" placeholder="Enter Reason..."
          v-model="returnForm.remarks" :class="{
            'is-invalid': submitted && returnForm.remarks == ''
          }">
        </textarea>
      </div>
      <div class="d-flex float-end">
        <button @click="onReturnTarget()" class="btn btn-primary">
          Return Target
        </button>
      </div>
    </b-modal>
    <!-- Logs -->
    <b-modal id="return-remarks-modal" title="Accomplishment Logs" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <ul class="verti-timeline list-unstyled ms-3" v-for="(remark, index) in returnRemarks" :key="index">
        <li class="event-list" :class="{
          active: index == 0
        }">
          <div class="event-timeline-dot">
            <i class="font-size-18" :class="index == 0
              ? 'bx bxs-right-arrow-circle bx-fade-right'
              : 'bx bx-right-arrow-circle'
              "></i>
          </div>
          <div class="media">
            <div class="me-3 mb-3">
              <h5 class="font-size-14 mb-0">
                {{ remark.splitted[0] }}
                <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
              </h5>
              <small>{{ remark.splitted[1] }}</small>
            </div>
            <div class="media-body">
              <div class="mb-0" style="line-height: 14px">
                {{ remark.Remarks }}
              </div>
              <div>
                <small>({{ remark.Employee }})</small>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </b-modal>
    <!-- Rate Target -->
    <b-modal id="rate-modal" :title="modalTitle" size="lg" title-class="font-18" hide-footer no-close-on-backdrop>
      <div v-if="actualSelected" class="mb-3 border p-3">
        <div class="mb-3">
          <div class="row">
            <div class="col-md-6">
              <label>Annual Target</label>
              <div class="d-flex align-items-center">
                <masked-input type="text" class="form-control w-100" placeholder="Annual Target"
                  v-model="actualSelected.annualTarget" :mask="currencyMask"></masked-input>
                <b v-if="actualSelected.isPercentage" class="ms-2">%</b>
              </div>
            </div>
            <div class="col-md-6">
              <label>Actual Accomplishment</label>
              <div class="d-flex align-items-center">
                <masked-input type="text" class="form-control w-100" placeholder="Annual Target"
                  v-model="actualSelected.actualAccomplishment" :mask="currencyMask"></masked-input>
                <b v-if="actualSelected.isPercentage" class="ms-2">%</b>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label :for="`planningFeedbackActual`">Validator's Feedback</label>
          <b-form-select class="form-select" v-model="actualSelected.planningFeedback">
            <b-form-select-option value="" disabled>Validator's Feedback...</b-form-select-option>
            <b-form-select-option value=""></b-form-select-option>
            <b-form-select-option value="LSD">Lacking supporting documents (LSD)</b-form-select-option>
            <b-form-select-option value="NTI">No Target Indicated (NTI)</b-form-select-option>
            <b-form-select-option value="NAI">No Accomplishment Indicated (NAI)</b-form-select-option>
            <b-form-select-option value="AIT">Accomplishment Inconsistent with Target
              (AIT)</b-form-select-option>
            <b-form-select-option value="ES">Evidence Sufficient (ES)</b-form-select-option>
            <b-form-select-option value="EIS">Evidence Insufficient (EIS)</b-form-select-option>
            <b-form-select-option value="LSE">Label Submitted Evidence (LSE)</b-form-select-option>
            <b-form-select-option value="NEA">No Evidence Attached (NEA)</b-form-select-option>
            <b-form-select-option value="NAVI">No Absolute Value Indicated (NAVI)</b-form-select-option>
            <b-form-select-option value="KNF">KPI not found in approved OPCR (KNF)</b-form-select-option>
            <b-form-select-option value="KFD">KPI Found in approved OPCR but Deleted
              (KFD)</b-form-select-option>
            <b-form-select-option value="FPD">For PMTs Deliberation (FPD)</b-form-select-option>
            <b-form-select-option value="WDRA">Wrong Dimension Rating (QET) as Agreed (WDRA)</b-form-select-option>
          </b-form-select>
        </div>
        <div class="mb-3">
          <label :for="`planningFeedbackActual`">Validator's Remarks</label>
          <textarea id="" rows="3" class="form-control" v-model="actualSelected.planningRemarks"
            placeholder="Enter Remarks" />
        </div>
        <div class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input type="checkbox" id="isNotApplicable" checked="checked" class="form-check-input"
              v-model="actualSelected.isNotApplicable" /><label for="isNotApplicable" class="form-check-label">
              QET Rating not applicable.
            </label>
          </div>
        </div>
        <b-collapse :visible="!actualSelected.isNotApplicable">
          <div v-if="!actualSelected.isNotApplicable">
            <div class="row">
              <div class="col-md-3">
                <label class="m-0 font-size-12">Effectiveness / Quality</label>
              </div>
              <div class="col-md-3">
                <label class="m-0">Efficiency</label>
              </div>
              <div class="col-md-3">
                <label class="m-0">Timeliness</label>
              </div>
              <div class="col-md-3">
                <label class="m-0">Average</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label class="font-size-11">Self Rating:
                  <span class="text-info font-size-14">
                    {{ actualSelected.scoreQuality }}
                  </span>
                </label>
              </div>
              <div class="col-md-3">
                <label class="font-size-11">Self Rating:
                  <span class="text-info font-size-14">
                    {{ actualSelected.scoreEfficiency }}
                  </span>
                </label>
              </div>
              <div class="col-md-3">
                <label class="font-size-11">Self Rating:
                  <span class="text-info font-size-14">
                    {{ actualSelected.scoreTimeliness }}
                  </span>
                </label>
              </div>
              <div class="col-md-3">
                <label class="font-size-11">Self Rating:
                  <span class="text-info font-size-14">
                    {{
                      calcAve(
                        actualSelected.scoreQuality,
                        actualSelected.scoreEfficiency,
                        actualSelected.scoreTimeliness
                      )
                    }}
                  </span>
                </label>
              </div>
            </div>
            <div class="row">
              <div v-if="actualSelected.qualityOptions" class="col-md-3">
                <b-input-group>
                  <template #append>
                    <b-button :id="`target-submitted-quality-${actualSelected.id}`" tabindex="0"
                      variant="outline-secondary"><i class="mdi mdi-menu-down"></i></b-button>
                    <b-popover :target="`target-submitted-quality-${actualSelected.id}`" triggers="click blur"
                      placement="bottom" variant="secondary" custom-class="p-0">
                      <b-list-group class="w-100 fit">
                        <div v-for="(rating,
                          ratingIndex) in actualSelected.qualityOptions" :key="ratingIndex">
                          <b-list-group-item button action @click="
                            actualSelected.evaluationScoreQuality = rating.rating.toString()
                            ">
                            <div class="d-flex">
                              <b class="text-center" style="width: 10px">{{
                                rating.rating
                              }}</b>
                              <div class="mx-2">-</div>
                              <div>
                                {{ rating.description }}
                              </div>
                            </div>
                          </b-list-group-item>
                        </div>
                        <b-list-group-item v-if="actualSelected.qualityOptions.length == 0">List is Empty
                        </b-list-group-item>
                      </b-list-group>
                    </b-popover>
                  </template>
                  <masked-input type="text" class="form-control" v-model="actualSelected.evaluationScoreQuality"
                    @input="limitRating(actualSelected)" :mask="currencyMask" />
                </b-input-group>
              </div>
              <div v-if="actualSelected.efficiencyOptions" class="col-md-3">
                <b-input-group>
                  <template #append>
                    <b-button :id="`target-submitted-efficiency-${actualSelected.id}`" tabindex="0"
                      variant="outline-secondary"><i class="mdi mdi-menu-down"></i></b-button>
                    <b-popover :target="`target-submitted-efficiency-${actualSelected.id}`
                      " triggers="click blur" placement="bottom" variant="secondary" custom-class="p-0">
                      <b-list-group class="w-100 fit">
                        <div v-for="(rating,
                          ratingIndex) in actualSelected.efficiencyOptions" :key="ratingIndex">
                          <b-list-group-item button action @click="
                            actualSelected.evaluationScoreEfficiency = rating.rating.toString()
                            ">
                            <div class="d-flex">
                              <b class="text-center" style="width: 10px">{{
                                rating.rating
                              }}</b>
                              <div class="mx-2">-</div>
                              <div>
                                {{ rating.description }}
                              </div>
                            </div>
                          </b-list-group-item>
                        </div>
                        <b-list-group-item v-if="actualSelected.efficiencyOptions.length == 0">List is Empty
                        </b-list-group-item>
                      </b-list-group>
                    </b-popover>
                  </template>
                  <masked-input type="text" class="form-control" v-model="actualSelected.evaluationScoreEfficiency"
                    @input="limitRating(actualSelected)" :mask="currencyMask" />
                </b-input-group>
              </div>
              <div v-if="actualSelected.timelinessOptions" class="col-md-3">
                <b-input-group>
                  <template #append>
                    <b-button :id="`target-submitted-timeliness-${actualSelected.id}`" tabindex="0"
                      variant="outline-secondary"><i class="mdi mdi-menu-down"></i></b-button>
                    <b-popover :target="`target-submitted-timeliness-${actualSelected.id}`
                      " triggers="click blur" placement="bottom" variant="secondary" custom-class="p-0">
                      <b-list-group class="w-100 fit">
                        <div v-for="(rating,
                          ratingIndex) in actualSelected.timelinessOptions" :key="ratingIndex">
                          <b-list-group-item button action @click="
                            actualSelected.evaluationScoreTimeliness = rating.rating.toString()
                            ">
                            <div class="d-flex">
                              <b class="text-center" style="width: 10px">{{
                                rating.rating
                              }}</b>
                              <div class="mx-2">-</div>
                              <div>
                                {{ rating.description }}
                              </div>
                            </div>
                          </b-list-group-item>
                        </div>
                        <b-list-group-item v-if="actualSelected.timelinessOptions.length == 0">List is Empty
                        </b-list-group-item>
                      </b-list-group>
                    </b-popover>
                  </template>
                  <masked-input type="text" class="form-control" v-model="actualSelected.evaluationScoreTimeliness"
                    @input="limitRating(actualSelected)" :mask="currencyMask" />
                </b-input-group>
              </div>
              <div class="col-md-3">
                <input type="text" class="form-control" disabled :value="calcAve(
                  actualSelected.evaluationScoreQuality,
                  actualSelected.evaluationScoreEfficiency,
                  actualSelected.evaluationScoreTimeliness
                )
                  " placeholder="Average" />
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="d-flex float-end">
        <button @click="onRateTarget()" class="btn btn-success">
          <i class="bx bx-save me-1"></i>
          {{
            rateType.includes("SUBMITTED")
              ? "Save & Complete Review"
              : "Update Review"
          }}
        </button>
      </div>
    </b-modal>
    <!-- Main -->
    <div style="min-width: 1300px">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <div style="width: 400px">
            <label class="mb-1">Cluster:</label>
            <div>
              <multiselect id="cluster" v-model="selectedCluster" track-by="clusterName" label="clusterName"
                placeholder="Select Cluster..." :show-labels="false" :options="clusterOptions" :searchable="true"
                :multiple="false" :allow-empty="false" :close-on-select="true"
                @input="getAllDu($store.state.data.cycle)">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{
                      props.option.clusterName
                    }}</span><span v-if="props.option.submittedCount"
                      class="option__small badge bg-danger rounded-pill font-size-12 ms-1">{{
                        props.option.submittedCount }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <transition>
            <div v-if="selectedCluster" style="min-width: 400px">
              <label class="mb-1">Delivery Unit:</label>
              <div>
                <multiselect id="deliveryUnit" v-model="selectedDu" track-by="deliveryUnitId" label="deliveryUnitName"
                  placeholder="Select Delivery Unit..." :show-labels="false" :options="duOptions" :searchable="true"
                  :multiple="false" :allow-empty="false" :close-on-select="true" @input="getAllTargets()">
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">{{
                        props.option.deliveryUnitName
                      }}</span><span v-if="props.option.submittedCount"
                        class="option__small badge bg-danger rounded-pill font-size-12 ms-1">{{
                          props.option.submittedCount }}</span>
                    </div>
                    <div class="option__label">
                      <small>{{ props.option.campusName }}</small>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </transition>
        </div>
        <div>
          <button type="button" class="btn btn-purple me-1" id="select-report" @click="renderSelection">
            <i class="bx bx-printer me-1"></i>Print OPCR By Filter
          </button>
          <b-popover :target="`select-report`" triggers="click" placement="left" :show.sync="filteredReport"
            custom-class="popover-report">
            <template v-slot:title>
              <div class="
                  d-flex
                  align-items-center
                  justify-content-between
                " style="color: #222736">
                <span class>Filter</span>
                <span class="
                      bx bx-x
                      font-size-14
                      cursor-pointer
                  " @click="filteredReport = false"></span>
              </div>
            </template>
            <div class="p-3">
              <div class="mb-2">
                <div class="mb-1">Print Report By</div>
                <div class="mb-2">
                  <div class="d-flex gap-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" name="printType" id="printTypeCampus" value="Campus"
                        v-model="printType" />
                      <label class="form-check-label" for="printTypeCampus">
                        {{ GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }}
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" name="printType" id="printTypeCluster"
                        value="Cluster" v-model="printType" />
                      <label class="form-check-label" for="printTypeCluster">
                        Cluster
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" name="printType" id="printTypePrexc" value="PREXC"
                        v-model="printType" />
                      <label class="form-check-label" for="printTypePrexc">
                        PREXC Classification
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" name="printType" id="printTypeSD"
                        value="SubmissionDates" v-model="printType" />
                      <label class="form-check-label" for="printTypeSD">
                        Submission Dates
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" name="printType" id="printTypeSum" value="Summary"
                        v-model="printType" />
                      <label class="form-check-label" for="printTypeSum">
                        Summary
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <div class="mb-1">{{ GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }}</div>
                <multiselect id="campus" v-model="selectedCampusPrint" track-by="Id" label="CampusName"
                  :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" :show-labels="true"
                  :options="campusList" :searchable="true" :multiple="printType === 'Cluster' ? true : false"
                  :allow-empty="false" :close-on-select="printType === 'Cluster' ? false : true" @input="
                    selectedClassificationPrint = null;
                  selectedPrexcPrint = [];
                  ">
                </multiselect>
              </div>
              <b-collapse :visible="selectedCampusPrint != null && printType === 'Cluster'">
                <div v-if="selectedCampusPrint != null">
                  <hr />
                  <div class="mb-2">
                    <div class="mb-1">Cluster</div>
                    <multiselect id="cluster" v-model="selectedClusterPrint" track-by="clusterName" label="clusterName"
                      placeholder="Select CLuster..." :show-labels="true" :options="clusterOptions" :searchable="true"
                      :multiple="false" :allow-empty="false" :close-on-select="true">
                    </multiselect>
                  </div>
                </div>
              </b-collapse>
              <b-collapse :visible="selectedCampusPrint != null && printType === 'PREXC'">
                <div v-if="selectedCampusPrint != null">
                  <hr />
                  <div class="mb-2">
                    <div class="mb-1">PREXC Classification</div>
                    <multiselect id="classification" v-model="selectedClassificationPrint" track-by="id"
                      label="classification" placeholder="Select PREXC Classification..." :show-labels="true"
                      :options="groupedPrexc" :searchable="true" :multiple="false" :allow-empty="true"
                      :close-on-select="true" @input="selectedPrexcPrint = []">
                    </multiselect>
                  </div>
                  <b-collapse :visible="selectedClassificationPrint != null">
                    <div v-if="selectedClassificationPrint != null" class="mb-2">
                      <div class="mb-1">PREXC</div>
                      <multiselect id="prexc" v-model="selectedPrexcPrint" track-by="id" label="prexcName"
                        placeholder="Select PREXC..." :show-labels="true"
                        :options="selectedClassificationPrint.prexcList" :searchable="true" :multiple="true"
                        :allow-empty="true" :close-on-select="false">
                      </multiselect>
                    </div>
                  </b-collapse>
                </div>
              </b-collapse>
              <hr />
              <button @click="printFilteredRatedOPCR()" type="button" class="
                  btn
                  btn-purple
                  btn-sm
                  btn-block
                ">
                <span
                  class="font-size-13                                                                                                                                                                                                                                                                                                    ">
                  <i class="
                      bx bx-printer
                      me-1
                    "></i>
                  Print Report
                </span>
              </button>
            </div>
          </b-popover>
        </div>
      </div>
      <div class="my-3">
        <div class="p-3 d-flex align-items-center" v-if="duBusy">
          <div class="preloader-component me-2">
            <div class="status">
              <div class="spinner-chase w-20px h-20px">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <h5 class="mb-0">Loading...</h5>
        </div>
        <div v-else-if="!selectedCluster || !selectedDu">
          <b-alert :show="true" variant="info">
            <div>
              No items available. Please select a
              {{ !selectedCluster ? "cluster" : "delivery unit" }}.
            </div>
            <small v-if="selectedCluster">
              If the delivery unit you are looking for is not available in
              {{ selectedCluster.clusterName }}, contact DTO.
            </small>
          </b-alert>
        </div>
        <div v-else>
          <div class="card mb-5">
            <div v-if="targetBusy" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <template v-if="!targetBusy && selectedClassification.items">
              <table class="table table-borderless mb-0">
                <tr v-for="(x, xIndex) in selectedClassification.items" :key="xIndex">
                  <td class="py-2 border-2 border-top-0 border-start-0 border-dark-app">
                    <b>{{ x.classification }} ({{ x.weight }}%)</b>
                  </td>
                  <td class="text-center col-3 border-2 border-top-0 border-start-0 border-end-0 border-dark-app">
                    <b>
                      {{ x.rating }}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td class="py-2 border-2 border-top-0 border-start-0 border-dark-app">
                    <b class="text-warning font-size-16">Total Score</b>
                  </td>
                  <td class="text-center col-3 border-2 border-top-0 border-start-0 border-end-0 border-dark-app">
                    <b class="text-warning font-size-16">{{ selectedClassification.finalRating }}</b>
                  </td>
                </tr>
              </table>
            </template>
          </div>
          <div class="position-relative">
            <div>
              <div class="text-right position-absolute" style="right: 0">
                <div class="d-flex align-items-center gap-2">
                  <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end" no-caret>
                    <template #button-content>
                      <i class="bx bx-printer me-1"></i>
                      Reports
                    </template>
                    <b-dropdown-item @click="printTPMS(selectedDu.deliveryUnitId)">TPMS</b-dropdown-item>
                    <b-dropdown-item @click="printRatedOPCR(selectedDu.deliveryUnitId)">Rated OPCR</b-dropdown-item>
                  </b-dropdown>
                  <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-input autocomplete="off" v-model="filter" type="search"
                        placeholder="Search KPI, Target..." class="form-control form-control-sm"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="mdi mdi-clock-time-four-outline"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Submitted Targets</span>
                  </template>
                  <TPMSList :tabOptions="tabOptions" :loading="targetBusy" :targetList="targetList" :filter="filter"
                    tabType="SUBMITTED" :selectedDu="selectedDu" @rateTarget="rateTarget" @returnTarget="returnTarget"
                    @getAttachments="getAttachments" @viewReturnRamarks="viewReturnRamarks" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="mdi mdi-clock-time-four-outline"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Completed Targets</span>
                  </template>
                  <TPMSList :tabOptions="tabOptions" :loading="targetBusy" :targetList="targetList" :filter="filter"
                    tabType="COMPLETED" :selectedDu="selectedDu" @rateTarget="rateTarget" @returnTarget="returnTarget"
                    @getAttachments="getAttachments" @viewReturnRamarks="viewReturnRamarks" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="mdi mdi-clock-time-four-outline"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">All Targets</span>
                  </template>
                  <TPMSList :tabOptions="tabOptions" :loading="targetBusy" :targetList="targetList" :filter="filter"
                    tabType="ALL" :selectedDu="selectedDu" @rateTarget="rateTarget" @returnTarget="returnTarget"
                    @getAttachments="getAttachments" @viewReturnRamarks="viewReturnRamarks" />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RatingScale ref="RatingScale"></RatingScale>
    <attachment-modal :wActions="false" :title="uploadTitle" ref="attachmentModal"></attachment-modal>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.popover-report {
  min-width: 700px !important;
}

.v-enter-active {
  animation: slide-in 0.3s;
}

.v-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
